import bankStyles from '../../assets/css/banks.module.css';
import { Paper } from '@mui/material';
import CountrySelect from './CountrySelect';
import BankSearch from './Search';
import { Ref } from 'react';
import { BankCountry } from '../../services/interfaces/bank.interface';

interface BankFiltersProps {
	country: BankCountry;
	searchRef?: Ref<HTMLInputElement>;
	onCountryChange(country: string): void;
	onSearchFilterChange(searchFilter: string): void;
}

const BankFilters = ({ country, onSearchFilterChange, onCountryChange, searchRef }: BankFiltersProps) => {
	return (
		<div className={bankStyles['bank-filters-container']}>
			<Paper elevation={1} className={bankStyles['bank-search-container']}>
				<BankSearch inputRef={searchRef} onSearchChange={onSearchFilterChange} />
			</Paper>
			<div className={bankStyles['filter-separator']}></div>
			<Paper elevation={1} className={bankStyles['bank-country-select-container']}>
				<div>
					<CountrySelect country={country} onCountryChange={onCountryChange} />
				</div>
			</Paper>
		</div>
	);
};

export default BankFilters;
